import { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { getResourceDownloadProps } from "Utils/fileDownloadUtil";
import { ICONS } from "Utils/icons";
import { config } from "Utils/config";

/**
 * 
 * @param {*} 
 * type:  ARTICLE: download
 *        EVENT: do nothing
 *        ANNOUNCEMENT: navigation
 * @returns 
 */
//DOWNLOAD
const NewsEventCard = ({
  type,
  postedDate,
  eventDate,
  eventTime,
  registrationEndDate,
  isRegistration,
  title,
  description,
  docGroupId,
  isWhatsNew = false,
  url
}) => {

  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(false);

  const renderIcon = (type) => {
    // Article/Announcement: show diagnal arrow icon
    if (String(type).toUpperCase() === "ARTICLE" || String(type).toUpperCase() === "ANNOUNCEMENT") {
      return (
        <span
          className={isActive ? "card-icon-active" : "card-icon"}
        >
          {ICONS.arrowOutward()}
        </span>
      )
    }

    return null;
  }

  const renderRegistrationPill = (isRegi) => {
    if (isRegi && isRegi === 1) {
      return <div className="reg-pill"><div className="registration">Registration Open</div></div>;
    }

    if (isRegi === 0) {
      return <div className="reg-pill"><div className="registration-closed">Registration Closed</div></div>;
    }
    return null;
  }

  // const renderRegistrationPillOnMobile = (isRegi) => {
  //   if (isRegi && isRegi === 1) {
  //     return (
  //       <div className="">
  //         <span className="registration">Registration Open</span>
  //       </div>);
  //   }

  //   if (isRegi === 0) {
  //     return (
  //       <div className="">
  //         <span className="registration-closed">Registration Closed</span>
  //       </div>);
  //   }
  //   return null;
  // }

  const getNavigationProps = (url) => {
    if (url) {
      return ({
        as: Link,
        to: url.includes("www.") ? url : url,
        target: url.includes("www.") ? "_blank" : "_self",
      });
    }
  }


  return (
    // ARTICLE/Announcement with url
    <>{(String(type).toUpperCase() === "ARTICLE") || ((String(type).toUpperCase() === "ANNOUNCEMENT") && url) ?
      <>
        {/* display > md */}
        <Card
          className={`w-100 article-announcement-card text-start ${isWhatsNew ? '' : 'event-card-background-color'}`}
          //{...getResourceDownloadProps(docGroupId)}
          {...getNavigationProps(url)}

        >
          <Card.Body>
            <div className="">
              <span className={"bodyS semibold " + (String(type).toUpperCase() === "ARTICLE" ? "type-article" : "type-announcement")}>{String(type).toUpperCase()}</span>
              {postedDate && <span className="divider-dot">
                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.01627 4.338C1.47627 4.338 1.00227 4.14 0.594274 3.744C0.198274 3.348 0.000273488 2.826 0.000273488 2.178C0.000273488 1.53 0.198274 1.008 0.594274 0.612C1.00227 0.204 1.47627 5.96046e-07 2.01627 5.96046e-07C2.55627 5.96046e-07 3.02427 0.204 3.42027 0.612C3.82827 1.008 4.03227 1.53 4.03227 2.178C4.03227 2.826 3.82827 3.348 3.42027 3.744C3.02427 4.14 2.55627 4.338 2.01627 4.338Z" fill="#686E7A" />
                </svg>
              </span>}
              <span className="date bodyS semibold">{postedDate}</span>
              {renderIcon(type)}
            </div>
            <div className="title">
              {title}
            </div>
            <div className="description">
              {description}
            </div>
            {/* {eventDate &&
              <div className='additional-info d-flex align-items-center flex-wrap'>
                <div className="info-date">
                  {ICONS.calendarToday()}
                  <div className=''>{eventDate}</div>
                </div>
                <div className="time">
                  {eventTime && <>
                    {ICONS.accessTime()}
                    <div className=''>{eventTime}</div> </>
                  }
                </div>
                {renderRegistrationPill(isRegistration)}

              </div>}
            {registrationEndDate &&
              <div className="reg-date-section">
                {ICONS.errorOutline()} <div className="bodyS regular">Registration Closes <span className="bodyS semibold">{registrationEndDate}</span></div>
              </div>
            } */}
          </Card.Body>
        </Card>


        {/* display < md */}
        {/* <Card
          className={`w-100 d-block d-md-none article-announcement-card text-start p-0 p-md-0 px-3 ${isWhatsNew ? '' : 'event-card-background-color'}`}
          {...getResourceDownloadProps(docGroupId)}
        >
          <Card.Body>
            <div className="my-1">
              <span className="type">{String(type).toUpperCase()}</span>
              {renderIcon(type)}
            </div>
            <div className="my-1">
              <span className="date">{postedDate}</span>
            </div>
            <div className="title">
              {title}
            </div>
            <div className="mt-1 description">
              {description}
            </div>
            {eventDate &&
              <div className='additional-info mt-2'>
                <div className="mt-2">
                  <span>{ICONS.calendarToday()}</span>
                  <span className='mx-2'>{eventDate}</span>
                </div>
                {eventTime &&
                  <div className="mt-2">
                    <span>{ICONS.accessTime()}</span>
                    <span className='mx-2'>{eventTime}</span>
                  </div>}
                {renderRegistrationPillOnMobile(isRegistration)}
              </div>}
            {registrationEndDate &&
              <>
                <hr />
                <div>
                  {ICONS.errorOutline()} Registration Closes <span className="fw-semibold">{registrationEndDate}</span>
                </div>
              </>
            }
          </Card.Body>
        </Card> */}
      </>
      :
      // EVENTS/static Announcement
      <Card
        className={`w-100 news-event-card ${isWhatsNew ? '' : 'event-card-background-color'}`}
      >
        <Card.Body>
          {/* display > md */}

          <div className="">
            <span className={"bodyS semibold " + (String(type).toUpperCase() === "EVENT" ? "type-event" : "type-announcement")}>{String(type).toUpperCase()}</span>
            {postedDate && <span className="divider-dot">
              <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.01627 4.338C1.47627 4.338 1.00227 4.14 0.594274 3.744C0.198274 3.348 0.000273488 2.826 0.000273488 2.178C0.000273488 1.53 0.198274 1.008 0.594274 0.612C1.00227 0.204 1.47627 5.96046e-07 2.01627 5.96046e-07C2.55627 5.96046e-07 3.02427 0.204 3.42027 0.612C3.82827 1.008 4.03227 1.53 4.03227 2.178C4.03227 2.826 3.82827 3.348 3.42027 3.744C3.02427 4.14 2.55627 4.338 2.01627 4.338Z" fill="#686E7A" />
              </svg>
            </span>}
            <span className="date bodyS semibold">{postedDate}</span>
          </div>

          {/* display > md */}

          <div className="title">
            {title}
          </div>
          <div className="description">
            {description}
          </div>
          {eventDate && (String(type).toUpperCase() === "EVENT") &&
            <div className='additional-info d-flex flex-column flex-md-row align-items-start align-items-md-center  flex-wrap gap-8px gap-md-16px'>
              <div className="info-date">
                {ICONS.calendarToday()}
                <div className=''>{eventDate}</div>
              </div>
              <div className="time">
                {eventTime && <>
                  {ICONS.accessTime()}
                  <div className=''>{eventTime}</div> </>
                }
              </div>
              {renderRegistrationPill(isRegistration)}
            </div>
          }
          {registrationEndDate && (String(type).toUpperCase() === "EVENT") &&
            <div className="reg-date-section">
              {ICONS.errorOutline()} <div className="bodyS regular">Registration Closes <span className="bodyS semibold">{registrationEndDate}</span></div>
            </div>
          }

          {/* display <= md */}
          {/* <Row className="d-block d-md-none">
            <Col>
              <div className="my-1">
                <span className={String(type).toUpperCase() === "EVENT" ? "type-event" : "type-announcement"}>{String(type).toUpperCase()}</span>
              </div>
            </Col>
          </Row>
          <Row className="d-block d-md-none">
            <Col>
              <div className="my-1">
                <span className="date">{postedDate}</span>
              </div>
            </Col>
          </Row>
          <Row className="d-block d-md-none">
            <Col>
              <div className="title">
                {title}
              </div>
              <div className="mt-1 description">
                {description}
              </div>
              {eventDate &&
                <div className='additional-info mt-2'>
                  <div className="mt-2">
                    <span>{ICONS.calendarToday()}</span>
                    <span className='mx-2'>{eventDate}</span>
                  </div>
                  {eventTime &&
                    <div className="mt-2">
                      <span>{ICONS.accessTime()}</span>
                      <span className='mx-2'>{eventTime}</span>
                    </div>}
                  {renderRegistrationPillOnMobile(isRegistration)}
                </div>}
              {registrationEndDate &&
                <>
                  <hr />
                  <div>
                    {ICONS.errorOutline()} Registration Closes <span className="fw-semibold">{registrationEndDate}</span>
                  </div>
                </>
              }
            </Col>
          </Row> */}
        </Card.Body>
      </Card>}
    </>
  )
}

export default NewsEventCard;